'use client';

import gsap from 'gsap/all';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Text, Container } from '@weareconceptstudio/core';

//* Styles
import MoveUpStyle from './style';

//* Component
import MoveItem from './MoveItem';

const MoveUp = ({ data }) => {
	//! Icon Data
	const iconData = ['tourist-up', 'resident-up', 'dilivery-up'];

	//! Ref
	const itemRef = data?.map(() => useRef(null));
	const scrollTriggerRef = useRef();

	useEffect(() => {
		ScrollTrigger.create({
			start: 'top 80%',
			end: 'top, top',
			// markers: true,
			trigger: '.content-wrapper',
			onEnter: () => {
				itemRef.forEach((item, i) => {
					gsap.to(item.current, {
						y: 0,
						duration: 0.5,
						ease: 'power1.out',
						delay: i * 0.1,
					});
				});
			},
		});

		return () => {
			if (scrollTriggerRef.current) scrollTriggerRef.current.kill();
		};
	}, []);

	return (
		<MoveUpStyle>
			<Container isSection>
				<Text
					className={'title-section h2 uppercase'}
					tag={'h2'}
					text={'moveUp'}
				/>
				<Container
					row
					full
					className='content-wrapper'>
					{data.map((item, i) => {
						return (
							<MoveItem
								key={i}
								iconName={iconData[i]}
								className={'col-4 col-t-6 col-m-12 item-move'}
								ref={itemRef[i]}
								{...item}
							/>
						);
					})}
				</Container>
			</Container>
		</MoveUpStyle>
	);
};

export default MoveUp;
